document.addEventListener("DOMContentLoaded", () => {
  const menuButton = document.querySelector("[data-ed-menu-toggle]");
  const navigation = document.getElementById("EditorialNavigation");
  const closeMenu = () => {
    navigation?.classList.remove("is-open");
    menuButton?.setAttribute("aria-expanded", "false");
  };
  menuButton?.addEventListener("click", () => {
    const open = navigation?.classList.toggle("is-open");
    menuButton.setAttribute("aria-expanded", String(Boolean(open)));
  });
  navigation?.querySelectorAll("a").forEach((link) => link.addEventListener("click", closeMenu));
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && navigation?.classList.contains("is-open")) {
      closeMenu();
      menuButton?.focus();
    }
  });

  const gallery = document.querySelector("[data-ed-gallery]");
  const mainImage = gallery?.querySelector("[data-ed-main-image]");
  gallery?.querySelectorAll("[data-ed-image]").forEach((button) => {
    button.addEventListener("click", () => {
      if (!mainImage) return;
      mainImage.src = button.dataset.edImage;
      mainImage.alt = button.dataset.edImageAlt || "";
      gallery.querySelectorAll("[data-ed-image]").forEach((thumbnail) => {
        thumbnail.classList.toggle("is-active", thumbnail === button);
        thumbnail.setAttribute("aria-pressed", String(thumbnail === button));
      });
    });
  });

  const form = document.getElementById("EditorialProductForm");
  if (!form) return;
  const quantity = form.querySelector('[name="quantity"]');
  form.querySelectorAll("[data-ed-quantity]").forEach((button) => {
    button.addEventListener("click", () => {
      const change = button.dataset.edQuantity === "up" ? 1 : -1;
      quantity.value = String(Math.min(99, Math.max(1, (Number(quantity.value) || 1) + change)));
      quantity.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });
  let strings = {};
  try { strings = JSON.parse(document.getElementById("EditorialStrings")?.textContent || "{}"); } catch {}
  const addButtons = Array.from(document.querySelectorAll("[data-ed-add]"));
  const error = form.querySelector("[data-ed-cart-error]");
  const variant = form.querySelector("[data-ed-variant]");
  const updateVariant = () => {
    const option = variant?.selectedOptions[0];
    if (!option) return;
    const available = option.dataset.available === "true";
    document.querySelectorAll("[data-ed-price]").forEach((price) => { price.textContent = option.dataset.price; });
    addButtons.forEach((button) => {
      button.disabled = !available;
      button.querySelector("span").textContent = available ? strings.add : strings.soldOut;
    });
  };
  variant?.addEventListener("change", updateVariant);
  let submitting = false;
  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (submitting || !form.reportValidity()) return;
    submitting = true;
    const data = new FormData(form);
    const labels = addButtons.map((button) => button.querySelector("span").textContent);
    addButtons.forEach((button) => {
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      button.querySelector("span").textContent = strings.adding || "Adding…";
    });
    if (error) error.hidden = true;
    try {
      const root = window.Shopify?.routes?.root || "/";
      const response = await fetch(root + "cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: data });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || strings.cartError);
      window.location.assign(root + "cart");
    } catch (failure) {
      if (error) {
        error.textContent = failure.message || strings.cartError;
        error.hidden = false;
      }
      submitting = false;
      addButtons.forEach((button, index) => {
        button.disabled = false;
        button.removeAttribute("aria-busy");
        button.querySelector("span").textContent = labels[index];
      });
    }
  });
  const sticky = document.querySelector("[data-ed-sticky]");
  if (sticky && "IntersectionObserver" in window) {
    const observer = new IntersectionObserver(([entry]) => {
      sticky.classList.toggle("is-visible", !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
    }, { threshold: 0 });
    observer.observe(form);
  }
});
